class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartForm = document.getElementById('AjaxCartForm');
		const cartItems = cartForm?.querySelectorAll('[data-js-cart-item]');
		if ( !cartItems?.length ) {
			this.innerHTML = '';
			return;
		}

		fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
			.then(response => response.text())
			.then(text => {
				const root = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('[data-js-cart-recommendations-performed]');
				if ( !root || !root.querySelectorAll('[data-js-product-item]').length ) {
					this.innerHTML = '';
					return;
				}
				this.innerHTML = root.innerHTML;
				this.bindAddButtons();
				const slider = this.querySelector('css-slider');
				if ( slider?.resetSlider ) {
					slider.resetSlider();
				}
			})
			.catch(e=>{
				console.warn(e);
			});
	}

	bindAddButtons(){
		this.querySelectorAll('[data-recommendation-add]').forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				this.addToCart(button);
			});
		});
	}

	addToCart(button){
		if ( button.disabled || button.getAttribute('aria-disabled') === 'true' ) return;

		const card = button.closest('.cart-rec-card');
		button.setAttribute('aria-disabled', 'true');
		card?.classList.add('working');

		const body = new URLSearchParams({
			id: button.dataset.variantId,
			quantity: '1',
		});
		const source =
			window.KROWN?.functions?.getCartLineItemSource?.(this) ||
			window.KROWN?.cartLineItemSources?.CART_DRAWER ||
			'cart drawer';
		body.append('properties[_source]', source);

		fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body,
		})
			.then(response => response.json())
			.then(response => {
				if ( response.status ) {
					throw new Error(typeof response.description === 'string' ? response.description : response.message);
				}
				return fetch('?section_id=helper-cart');
			})
			.then(response => response.text())
			.then(text => {
				if ( typeof window.renderHelperCart === 'function' ) {
					window.renderHelperCart(text, { defaultShipping: true });
				}
				if ( typeof window.KROWN?.functions?.showCartOrderSlots === 'function' ) {
					window.KROWN.functions.showCartOrderSlots();
				}
				document.getElementById('site-cart-sidebar')?.scrollTo({ top: 0, behavior: 'smooth' });
				this.generateRecommendations();
			})
			.catch(error => {
				console.warn(error);
			})
			.finally(() => {
				button.removeAttribute('aria-disabled');
				card?.classList.remove('working');
			});
	}
}
customElements.define('cart-recommendations', CartRecommendations);
